<new-auth-page>
    <div left>
      <h1>Forgot Password</h1>
      <p>Don't have an account?</p>
      <a [routerLink]="['/register']" class="link" trans>Register</a>
    </div>
    <form 
        form
        (ngSubmit)="sendPasswordResetLink()" 
        *ngIf="errors$ | async as errors" 
        [formGroup]="form" 
        ngNativeValidate
    >
        <div class="header" trans>Enter your email address below and we will send you a link via mail to reset your password.</div>

        <div class="many-inputs">
            <div class="input-container">
                <input type="email" formControlName="email" id="email" placeholder="Enter Email Address" required>
                <p class="error big-error" *ngIf="errors.email">
                    <mat-icon svgIcon="warning"></mat-icon>
                    <span>{{errors.email}}</span>
                </p>
            </div>

            <button type="submit" [disabled]="loading$ | async" trans>Continue</button>
        </div>
    </form>
</new-auth-page>
